module.exports = "https://cdn.dove.it/_next/static/public/assets/services/consulenti.a2bfe484ed1280aa32b3bba7c5986cee.jpg";